/**
 * Omniture Service -- Public API
 *
 * Provides logClick() and logPageLoad() for direct use, and
 * fireTrackingEvents() for backend-driven tracking payloads.
 * Safe to call before pwatracker.js loads (events are buffered and retried).
 */
import type { TrackingInfo } from '@contracts';
import type { OmnitureData } from './types';
import { omnitureQueue } from './omnitureEventQueue';

export function logClick(data: OmnitureData): void {
  omnitureQueue.enqueueEvent(data, 'CLICK');
}

export function logPageLoad(data: OmnitureData): void {
  omnitureQueue.enqueueEvent(data, 'LOAD');
}

/**
 * Fire all omniture page load events from a backend-driven TrackingInfo payload.
 * Merges common.omniture into each pageLoad.omniture event and fires s.t().
 * Safe to call with undefined -- no-ops silently.
 */
export function fireTrackingEvents(trackingInfo: TrackingInfo | null | undefined): void {
  if (!trackingInfo) return;
  const commonPayload = trackingInfo.common?.omniture ?? {};
  const pageLoadEvents = trackingInfo.pageLoad?.omniture;
  if (!pageLoadEvents?.length) return;

  for (const eventPayload of pageLoadEvents) {
    const mergedPayload: OmnitureData = { ...commonPayload, ...eventPayload };
    logPageLoad(mergedPayload);
  }
}
